import { render, staticRenderFns } from "./PratichePreview.vue?vue&type=template&id=0b719434&"
import script from "./PratichePreview.vue?vue&type=script&lang=js&"
export * from "./PratichePreview.vue?vue&type=script&lang=js&"
import style0 from "./PratichePreview.vue?vue&type=style&index=0&id=0b719434&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b719434')) {
      api.createRecord('0b719434', component.options)
    } else {
      api.reload('0b719434', component.options)
    }
    module.hot.accept("./PratichePreview.vue?vue&type=template&id=0b719434&", function () {
      api.rerender('0b719434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/PratichePreview.vue"
export default component.exports